import { composeSelectors } from "seneca-common/utils/selectors/compose-selectors";

import { CourseStats } from "../../../../models/state/courseStats";
import * as statSelectors from "./stat";
import { CourseStatsSelectors } from "./types";

function getCourseStat(state: CourseStats, courseId: string) {
  return state.get(courseId);
}

// @ts-ignore
export const {
  getTotalStudyTime,
  getScore,
  getSessionsCompleted,
  getNumberOfModulesStudied,
  getProficiency,
  getLastStudied
}: CourseStatsSelectors<CourseStats> = composeSelectors(
  getCourseStat,
  statSelectors
);
